/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Inject, Input, NgZone, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import * as _ from 'lodash';

import template from './scanned-creatives.component.html';
import {LocalNetworkInfo} from '../../../components/session/local-network-info';
import {AdnCheckerService} from '../../../components/util/adn-checker.service';
import {StateService} from '@uirouter/core';

@Component({
  standalone: false,
  selector: 'adn-scanned-creatives',
  template
})
export class ScannedCreativesComponent implements OnInit, OnChanges {
  @Input() refresh: any;
  @Input() limit: any[];
  @Input() singular: boolean | string;

  violationCheck = false;
  showFullDetails = false;
  violations: any[] = [];

  constructor(
    @Inject(AdnCheckerService) private readonly adnChecker: any,
    private readonly $state: StateService,
    private readonly ngZone: NgZone,
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.loadViolations();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const inputKeys = ['limit', 'singular', 'refresh'];
    if (inputKeys.some((key) => changes[key] && !changes[key].firstChange)) {
      this.loadViolations();
    }
  }

  get enabled(): boolean {
    return LocalNetworkInfo.obtain().getInfo('scanEnabledSites') > 0;
  }

  get isSingular(): boolean {
    return this.singular === true || this.singular === 'true';
  }

  creativeHref(id: string): string {
    return this.$state.href('app.adv.creatives.creative', {id});
  }

  private loadViolations(): void {
    if (!this.enabled) {
      return;
    }

    this.violationCheck = false;
    const limitIds = _.map(this.limit || [], 'id');

    this.adnChecker.getBlockedCreatives(this.refresh).then(
      (data: any[]) => {
        this.ngZone.run(() => {
          this.violations = _.filter(data || [], (violation: any) => {
            const hasViolation = violation.violations.length;
            return this.limit ? limitIds.indexOf(violation.creative.id) > -1 && hasViolation : hasViolation;
          });
          this.violationCheck = true;
          this.showFullDetails = false;
          this.cdr.markForCheck();
        });
      },
      () => {
        this.ngZone.run(() => {
          this.violations = [];
          this.violationCheck = true;
          this.showFullDetails = false;
          this.cdr.markForCheck();
        });
      }
    );
  }
}
